var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _vm.$checkPermission(["module_PRPriceFCLReal"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("Pricing.FCL"),
                      name: "fclRealList",
                      lazy: true
                    }
                  },
                  [
                    _c("fcl-real-list", {
                      ref: "fclRealList",
                      attrs: { "config-module": "220101" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.$checkPermission(["module_PRPriceLCLReal"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("Pricing.LCL"),
                      name: "lclRealList",
                      lazy: true
                    }
                  },
                  [
                    _c("lcl-real-list", {
                      ref: "lclRealList",
                      attrs: { "config-module": "220102" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.$checkPermission(["module_PRPriceAirReal"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("Pricing.Air"),
                      name: "airRealList",
                      lazy: true
                    }
                  },
                  [
                    _c("air-real-list", {
                      ref: "airRealList",
                      attrs: { "config-module": "220103" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_PrePort"),
                  name: "pricePrePortList",
                  lazy: true
                }
              },
              [
                _c("price-pre-port-list", {
                  ref: "pricePrePortList",
                  attrs: { source: "priceLook" }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_FinalMile"),
                  name: "priceLastMileList",
                  lazy: true
                }
              },
              [
                _c("price-last-mile-list", {
                  ref: "priceLastMileList",
                  attrs: { source: "priceLook" }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }